// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"c20d4bd2","818":"5592b210"}[chunkId] + ".css";
};